import { getOwnerDeductibleAndAlreadyPaidAmountQuery } from './getOwnerDeductibleAndAlreadyPaidAmountQuery';

export const CommonPaymentService = {
  getOwnerDeductibleAndAlreadyPaidAmountQuery,
};
